'use strict';

var availabilityStatus = require('../../../../../../../../_virtual/availabilityStatus.cjs');

var hasRequiredAvailabilityStatus;

function requireAvailabilityStatus () {
	if (hasRequiredAvailabilityStatus) return availabilityStatus.__exports;
	hasRequiredAvailabilityStatus = 1;

	var AvailabilityStatus = /*#__PURE__*/ function(AvailabilityStatus) {
	    AvailabilityStatus["AVAILABLE"] = "Available";
	    AvailabilityStatus["IN_STOCK"] = "In Stock";
	    AvailabilityStatus["BACKORDERED"] = "Backordered";
	    AvailabilityStatus["VENDOR_BACKORDER"] = "Vendor backorder";
	    AvailabilityStatus["UNAVAILABLE"] = "Unavailable";
	    AvailabilityStatus["DISCONTINUED"] = "Discontinued";
	    AvailabilityStatus["TO_BE_DISCONTINUED"] = "To be discontinued";
	    AvailabilityStatus["NA"] = "n/a";
	    AvailabilityStatus["NEW"] = "New";
	    AvailabilityStatus["NOT_IN_CATALOG"] = "Not in catalog";
	    AvailabilityStatus["FULLY_RESTRICTED"] = "Restricted";
	    return AvailabilityStatus;
	}({});

	availabilityStatus.__exports.AvailabilityStatus = AvailabilityStatus;
	
	return availabilityStatus.__exports;
}

exports.__require = requireAvailabilityStatus;
//# sourceMappingURL=availabilityStatus.cjs.map
